
export default function getApiVersion() {
  const version = process.env.REACT_APP_API_VERSION

  return `v${version.split('.')[0]}`
}